import { USERS_ACTIONS } from 'Actions/index';
import client from 'graphQl/apollo';
import { GET_USERS } from 'graphql/queries/users';

const {
  SET_USERS,
  SELECT_USER,
  SET_USERS_DATA_LOADING,
  SET_USER_CURRENT_ACTION,
} = USERS_ACTIONS;

const setUsers = data => ({
  type: SET_USERS,
  payload: data,
});

export function getUsers(search, page, filters) {
  return async dispatch => {
    try {
      dispatch({
        type: SET_USERS_DATA_LOADING,
        payload: {},
      });
      let data = await client.query({
        query: GET_USERS,
        variables: {
          search,
          page,
          filters,
        },
      });
      dispatch(setUsers(data.data.searchCustomers));
    } catch (err) {
      console.error(err);
    }
  };
}

export const selectUser = userId => dispatch =>
  dispatch({
    type: SELECT_USER,
    payload: userId,
  });

export const setUserCurrentAction = payload => dispatch =>
  dispatch({
    type: SET_USER_CURRENT_ACTION,
    payload: payload,
  });
